import React, { useEffect, useState } from "react";
import { apiClient } from "../../../apiclient/apiclient";
import OrderCard from "./OrderCard"
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
import PageHeader from "../../../components/PageHeader";
const CompletedOrders = () => {
 
  const [orders, setOrders] = useState([]);
const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

 const load = async () => {
  try {
    setLoading(true);     // ✅ start loader
    const res = await apiClient.get("/all-order?status=completed");
    setOrders(res.data.data);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);    // ✅ stop loader
  }
};


  useEffect(() => { load(); }, []);

  return (
    <div className="">
      <PageHeader
  title="Completed Orders"
  subtitle="Orders that have been completed"
  role="agent"
  variant="orange"   // same gradient you liked
  leftContent={
    <button onClick={() => navigate(-1)}>
      <ArrowLeft size={22} />
    </button>
  }
/>


     {loading ? (
  <Loader text="Loading completed orders..." />
) : orders.length === 0 ? (
  <p className="text-gray-500 text-center py-6">
    No completed orders
  </p>
) : (
  <div className="space-y-4 p-3">
    {orders.map((order) => (
      <OrderCard
        key={order._id}
        order={order}
        reload={load}
      />
    ))}
  </div>
)}
    </div>
  );
};

export default CompletedOrders;
